import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { formatAddresses } from '/imports/api/devtools';
import { clientDownloadUrl } from '/imports/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';
import { FileInput } from '/imports/ui/FileInput';
import { maxTextImportBytes } from '/imports/api/files';

/** Dev tool that uploads a list of addresses and downloads Google-formatted versions. */
export const DevToolFormatAddresses = () => {
  const [loading, setLoading] = useState(false);
  const handleFile = async (file: File) => {
    setLoading(true);
    try {
      const text = await file.text();
      const addresses = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
      if (addresses.length) {
        const url = await formatAddresses.call({ addresses });
        if (url) clientDownloadUrl(url);
      }
    }
    catch (error: any) {
      console.log(error);
      toast.error(error.message || error.reason || `${error}`);
    }
    finally {
      setLoading(false);
    }
    return file;
  };
  return (
    <DevToolSection
      title="Format Addresses"
      description="Upload a .txt or .csv file with one address per line. Downloads a new file with Google's formatted addresses, in the same order."
    >
      {loading
        ? <div>Running...</div>
        : <FileInput accept=".txt,.csv,text/plain,text/csv" maxSize={maxTextImportBytes} onFile={handleFile} />
      }
    </DevToolSection>
  );
};
